import React, { useRef, forwardRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { Box, useTheme } from '@mui/material';

const CustomScrollbar = forwardRef(
  ({ className, children, thumbColor, thumbHoverColor, thumbWidth, ...rest }, ref) => {
    const theme = useTheme();
    const scrollbarsRef = useRef(null);

    useImperativeHandle(ref, () => ({
      scrollToBottom: () => {
        if (scrollbarsRef.current) {
          scrollbarsRef.current.scrollToBottom();
        }
      }
    }));

    return (
      <Scrollbars
        renderView={(props) => (
          <div
            {...props}
            className="custom-scrollbar-view"
            style={{
              ...props.style,
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
              paddingRight: 20
            }}
          />
        )}
        renderThumbVertical={() => {
          return (
            <Box
              sx={{
                width: thumbWidth || 10,
                background: thumbColor || theme.colors.alpha.black[30],
                borderRadius: `${theme.general.borderRadiusLg}`,
                transition: `${theme.transitions.create(['background'])}`,
                '&:hover': {
                  background: thumbHoverColor || theme.colors.alpha.black[50]
                }
              }}
            />
          );
        }}
        ref={scrollbarsRef}
        {...rest}
      >
        {children}
      </Scrollbars>
    );
  }
);

CustomScrollbar.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  thumbColor: PropTypes.string,
  thumbHoverColor: PropTypes.string,
  thumbWidth: PropTypes.number
};

export default CustomScrollbar;
